import { Record } from "immutable"

const AdditionalService = new Record({
  id: null,
  category: null, // TODO: Enum
  backendCategory: null,
  status: null,

  created: null, // timestamp
  expiresAt: null, // timestamp
  updated: null, // timestamp // TODO: Check from additional bookings

  payment: null,
  params: null,
  assets: null, // check if needed

  description: null, // optional, booker's message
  orderItems: null,
  offerId: null,

  itineraryChangeType: null,
})

export default AdditionalService
